<template>
  <div class="hpanel">
    <template v-if="listId == null">
      <div class="panel-heading">
        <span class="label label-warning"> <i>Beta</i></span> Monitored queries <span v-if="queries.length">({{queries.length}})</span>
      </div>
      <div class="panel-body list no-padding">
        <table class="table table-responsive table-condensed">
          <thead>
          <tr>
            <th class="col-xs-2 col-md-2 col-lg-2">Query</th>
            <th class="col-xs-1 col-md-1 col-lg-1">Type</th>
            <th class="col-xs-2 col-md-2 col-lg-2">Project</th>
            <th class="col-xs-2 col-md-2 col-lg-2">Subproject</th>
            <th class="col-xs-1 col-md-1 col-lg-1">Periodicity</th>
            <th class="col-xs-2 col-md-2 col-lg-2 text-center">New documents</th>
            <th class="col-xs-1 col-md-1 col-lg-1">Next update</th>
            <th class="col-xs-1 col-md-1 col-lg-1 text-center">Actions</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr v-if="queries.length !== 0" v-for="(query, key) in queries" :key="key">
            <td>
              {{query.search_terms.term}}
            </td>
            <td>
              {{searchType(query.search_type)}}
            </td>
            <td>
              <template v-if="query.list_id !== null">
                <router-link :to="{name: 'ProjectDetails', params: {id: query.list.projects[0].id}}">
                  <h5 class="text-info" :title="query.list.projects[0].description"> {{query.list.projects[0].name}}</h5>
                </router-link>
              </template>
              <span v-else style="font-style: italic"> <i class="fas fa-info-circle text-info" data-toggle="popover" :data-content="'only for silver account or above'"></i> (Not applicable)</span>
            </td>
            <td>
              <template v-if="query.list_id !== null">
                {{query.list.title}}
              </template>
              <span v-else style="font-style: italic"> <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="'only for silver account or above'"></i> (Not applicable)</span>
            </td>
            <td>
              {{frequency(query.frequency)}}
            </td>
            <td class="text-center">
              <template v-if="query.new_documents !== null">
                {{query.new_documents.length}}
              </template>
            </td>
            <td>
              {{nextUpdate(query.frequency, (query.notified_at === null ? query.updated_at : query.notified_at))}}
            </td>
            <td class="text-center">
              <div class="btn-group">
                <button type="button" class="btn-outline btn btn-xs btn-info dropdown-toggle" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" :id="'dropdownMenu-' + query.id">
                  <i class="pe-7s-more pe-1x fa-rotate-90"></i>
                </button>
                <ul class="dropdown-menu pull-right">
                  <li><a role="button" @click="dropDownClick('search', query, $event)"><i class="fa fa-search text-info"></i> Launch search</a></li>
                  <li><a role="button" @click="dropDownClick('edit', query, $event)"><i class="fa fa-edit text-warning"></i> Edit</a></li>
                  <li><a role="button" @click="dropDownClick('delete', query, $event)"><i class="fa fa-remove text-danger"></i> Delete</a></li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="queries.length === 0">
            <td colspan="7" class="text-center"> Monitor queries (keywords, expert names) in order to replay them periodically</td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="panel-heading " @click="showHide" style="cursor: pointer">
        <span class="label label-warning"> <i>Beta</i></span> Monitored queries
        <div class="pull-right text-right">
          <button type="button" class="btn btn-info btn-outline btn-xs showhide">
            <i class="fa fa-chevron-up"></i>
          </button>
        </div>
      </div>
      <div class="panel-body">
        <table class="table table-responsive table-condensed">
          <thead>
          <tr>
            <th class="col-xs-3">Query</th>
            <th class="col-xs-2">Type</th>
            <th class="col-xs-1">Periodicity</th>
            <th class="col-xs-2 text-center">New documents</th>
            <th class="col-xs-1">Next update</th>
            <th class="col-xs-1 text-center">Actions</th>
          </tr>
          </thead>
          <tbody class="table-body">
          <tr v-if="queries.length !== 0" v-for="(query, key) in queries" :key="key">
            <td>
              {{query.search_terms.term}}
            </td>
            <td>
              {{searchType(query.search_type)}}
            </td>
            <td>
              {{frequency(query.frequency)}}
            </td>
            <td class="text-center">
              <template v-if="query.new_documents !== null">
                {{query.new_documents.length}}
              </template>
            </td>
            <td>
              {{nextUpdate(query.frequency, (query.notified_at === null ? query.updated_at : query.notified_at))}}
            </td>
            <td class="text-center">
              <div class="btn-group">
                <button type="button" class="btn-outline btn btn-xs btn-info dropdown-toggle" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false" :id="'dropdownMenu-' + query.id">
                  <i class="pe-7s-more pe-1x fa-rotate-90"></i>
                </button>
                <ul class="dropdown-menu pull-right">
                  <li><a role="button" @click="dropDownClick('search', query, $event)"><i class="fa fa-search text-info"></i> Launch search</a></li>
                  <li role="separator" class="divider"></li>
                  <li><a role="button" @click="dropDownClick('edit', query, $event)"><i class="fa fa-edit text-warning"></i> Edit</a></li>
                  <li><a role="button" @click="dropDownClick('delete', query, $event)"><i class="fa fa-remove text-danger"></i> Delete</a></li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="queries.length === 0">
            <td colspan="5" class="text-center"> Monitor queries (keywords, expert names) in order to replay them periodically</td>
          </tr>
          </tbody>
        </table>
      </div>
    </template>

    <edit-followed-search ref="editFollowedSearch"></edit-followed-search>
    <delete-followed-search ref="deleteFollowedSearch" @updateFollowedSearch="getResources"></delete-followed-search>
  </div>
</template>

<script>

import EditFollowedSearch from '../modal/EditFollowedSearch'
import {formatSearchForUrl} from '../../assets/scripts/search'
import DeleteFollowedSearch from '../modal/DeleteFollowedSearch'
export default {
  components: {DeleteFollowedSearch, EditFollowedSearch},
  props: {
    'listId': {
      default: null
    },
    'showLimitPlan': {
      required: true
    }
  },
  name: 'FollowedQueries',
  data () {
    return {
      queries: [],
      boxOpen: false
    }
  },
  methods: {
    getResources: function () {
      let url = 'dashboard/followedQueries'
      if (this.listId !== null) {
        url = 'list/followedQueries/' + this.listId
      }

      this.axios.get(url).then((response) => {
        this.queries = response.data
      })
    },
    searchType: function (searchType) {
      let type

      switch (searchType) {
        case 0:
          type = 'Science'
          break
        case 1:
          type = 'Patent'
          break
        case 3:
          type = 'Company'
          break
      }
      return type
    },
    frequency: function (enumFrequency) {
      let frequency

      switch (enumFrequency) {
        case '1_MONTH':
          frequency = 'every month'
          break
        case '3_MONTH':
          frequency = 'every 3 month'
          break
        case '6_MONTH':
          frequency = 'every 6 month'
          break
        case '12_MONTH':
          frequency = 'every 12 month'
          break
      }
      return frequency
    },
    nextUpdate: function (enumFrequency, notifiedAt) {
      if (notifiedAt !== null) {
        notifiedAt = this.$moment(notifiedAt)

        switch (enumFrequency) {
          case '1_MONTH':
            notifiedAt.add(1, 'M')
            break
          case '3_MONTH':
            notifiedAt.add(3, 'M')
            break
          case '6_MONTH':
            notifiedAt.add(6, 'M')
            break
          case '12_MONTH':
            notifiedAt.add(12, 'M')
            break
        }
        return notifiedAt.format('LL')
      }
    },
    dropDownClick: function (action, query, event) {
      event.preventDefault()
      let basicPlan = this.$user.isBasic()

      switch (action) {
        case 'edit':
          if (basicPlan) {
            this.showLimitPlan()
          } else {
            this.$refs.editFollowedSearch.setFollowedSearch(query)
            this.$refs.editFollowedSearch.openModal()
          }
          break
        case 'delete':
          this.$refs.deleteFollowedSearch.setFollowedSearch(query)
          this.$refs.deleteFollowedSearch.openModal()
          break
        case 'search':
          let queryParams = {'typeSearched': query.search_type}

          if (query.list_id !== null) {
            queryParams.projectId = query.list.projects[0].id
            queryParams.listId = query.list_id
          }

          let search = formatSearchForUrl(query.search_terms.term)
          this.$router.push({name: 'FollowSearch', params: {search: search}, query: queryParams})
          break
      }

      $('#dropdownMenu-' + query.id).dropdown('toggle')

      if (typeof event.stopPropagation !== 'undefined') {
        event.stopPropagation()
      }
    },
    showHide: function (event) {
      if (event !== null) {
        event.preventDefault()
      }

      let hpanel = $(this.$el).closest('div.hpanel')
      let iconUp = $(this.$el).find('.fa-chevron-up')
      let iconDown = $(this.$el).find('.fa-chevron-down')
      let body = hpanel.find('div.panel-body:first')

      if (typeof iconUp !== 'undefined' && iconUp.length !== 0) {
        iconUp.toggleClass('fa-chevron-down').toggleClass('fa-chevron-up')
        this.boxOpen = false
      } else if (typeof iconDown !== 'undefined' && iconDown.length !== 0) {
        iconDown.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        this.boxOpen = true
      }

      body.slideToggle(300)
      hpanel.toggleClass('').toggleClass('panel-collapse')

      localStorage.setItem('followedSearchBoxOpen', this.boxOpen)
    }
  },
  updated () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top'
    })
  },
  beforeMount () {
    this.boxOpen = localStorage.getItem('followedSearchBoxOpen') === 'true'

    this.getResources()
  },
  mounted () {
    if (this.boxOpen === false && this.$route.name === 'ProjectDetails') {
      this.showHide(null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/FollowedQueries.vue